export default "__VITE_ASSET__qavBzlJA__"